export default {
  state: {
    isMobile: true,
    wpSiteUrl: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_DEV_WP_SITE_URL : process.env.VUE_APP_PRO_WP_SITE_URL
  },
  setIsMobile() {
    this.state.isMobile = window.matchMedia('(max-width: 768px)').matches ? true : false
  }
}